<!--
 * @Author: katty 15032801667@163.com
 * @Date: 2022-12-01 18:09:41
 * @LastEditors: katty 15032801667@163.com
 * @LastEditTime: 2022-12-29 11:04:51
 * @FilePath: \epec-ea\src\modules\projectA\pages\approve\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: katty 15032801667@163.com
 * @Date: 2022-12-01 17:59:32
 * @LastEditors: katty 15032801667@163.com
 * @LastEditTime: 2022-12-02 09:54:35
 * @FilePath: \epec-ea\src\modules\projectA\pages\approve\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="padding: 20px">
    <div>审批流程设置</div>
    <div v-for="(item, index) in purchaseList" :key="index" class="approve">
      <div class="left">
        <div class="circle">
          <img :src="item.img" />
        </div>

        <div class="left-content">
          <div class="purchase-name">{{ item.purchaseName }}</div>
          <div class="purchase-desc">{{ item.describe }}</div>
        </div>
      </div>

      <div class="right">
        启用状态
        <el-switch
          v-if="item.type == 0"
          v-model="flag[item.type]"
          active-color="#13ce66"
          inactive-color="#808A87"
          style="margin-left: 10px"
          @input="handleOrderSwitch($event, item.type)"
        ></el-switch>
        <!-- 选商定价-->
        <el-switch
          v-else-if="item.type === 6"
          v-model="flag[item.type]"
          active-color="#13ce66"
          inactive-color="#808A87"
          style="margin-left: 10px"
          @input="handleOrderAskPriceSwitch($event, item.type)"
        ></el-switch>
        <el-switch
          v-else
          v-model="flag[item.type]"
          active-color="#13ce66"
          inactive-color="#808A87"
          style="margin-left: 10px"
          @input="handleSwitch($event, item.type)"
        ></el-switch>
        <el-button style="margin-left: 30px" type="primary" @click="chooseApproveFlow(item.type)">
          审批流程配置
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../../api/approve/index.js';
import CompnanyApi from '../../api/company/index.js';

export default {
  name: 'EpecEaIndex',

  data() {
    return {
      purchaseList: [
        {
          purchaseName: '提交订单',
          describe: '用于企业采购提交订单审批',
          img: require('../../../../assets/img/purchase/order.png'),
          type: 0,
        },
        {
          purchaseName: '需求计划',
          describe: '用于企业需求计划提报审批',
          img: require('../../../../assets/img/purchase/purchase.png'),
          type: 2,
        },
        {
          purchaseName: '采购计划',
          describe: '用于企业采购计划提报审批',
          img: require('../../../../assets/img/purchase/requirement.png'),
          type: 3,
        },
        {
          purchaseName: '询比价',
          describe: '用于询比价发起流程审批',
          img: require('../../../../assets/img/purchase/enquire.png'),
          type: 4,
        },
        {
          purchaseName: '询比价选商定价',
          describe: '用于询比价选商等流程审批',
          img: require('../../../../assets/img/purchase/vendorPricing.png'),
          type: 6,
        },
        {
          purchaseName: '公告',
          describe: '用于公告等流程审批',
          img: require('../../../../assets/img/purchase/gonggao@2.png'),
          type: 8,
        },
      ],
      flag: [false, false, false, false, false, false, false, false],
    };
  },
  watch: {
    // 利用watch方法检测路由变化：
    $route() {
      this.queryApprovalProcessSwitch();
      this.queryOrderApprovalProcessSwitch();
      this.queryOrderAskPrice(); // 查询选商定价
    },
  },

  mounted() {
    this.queryApprovalProcessSwitch();
    this.queryOrderApprovalProcessSwitch();
    this.queryOrderAskPrice(); // 查询选商定价
  },
  methods: {
    // 查询选商定价开关
    async queryOrderAskPrice() {
      const res = await Api.queryOrderAskPrice({});
      if (res.code === '200' && res.data.data === '41') {
        this.$set(this.flag, 6, true);
      } else {
        this.$set(this.flag, 6, false);
      }
    },
    async handleSwitch(val, index) {
      console.log(index, 'handleSwitch');
      if (this.flag[index]) {
        const dataTypeNum = [1, 2, 3, 4, 5, 6];
        // 开启审批流之前，查看是否配置有审批流
        const params = {
          auditName: '',
          createMemberName: '',
          pageSize: 10,
          pageNum: 1,
          auditType: dataTypeNum[index] ?? 8,
        };
        console.log(params, 'params-workflowData');
        const workflowData = await Api.listWorkflow(params);
        console.log(workflowData, 'workflowData');
        if (workflowData.data.total) {
          // 如果有审批流则调接口
          /* const dataType = [
            // 'orderSubmit',
            '',
            '',
            'orderDemand',
            'orderPlan',
            'orderAsk',
            'companyAnnouncement',
          ]; */
          const dataType = {
            // 'orderSubmit':0,
            2: 'orderDemand',
            3: 'orderPlan',
            4: 'orderAsk',
            8: 'companyAnnouncement',
          };
          console.log(index, '的是发送到发送到', dataType[index]);
          const res = await Api.saveApprovalProcessSwitch({
            dataType: dataType[index],
            data: this.flag[index] ? '41' : '42',
          });
          if (res.code === '200') {
            const message = this.flag[index] ? '审批流打开' : '审批流关闭';
            this.$message.success(message);
            // this.getWorkflowList();
          }
        } else {
          this.$set(this.flag, index, false);
          this.$message({
            type: 'warning',
            message: '请至少添加一条审批流程后再开启审批开关',
            duration: 1000,
          });
        }
      } else {
        /* const dataType = [
          // 'orderSubmit',\
          '',
          '',
          'orderDemand',
          'orderPlan',
          'orderAsk',
          'companyAnnouncement',
        ]; */
        const dataType = {
          // 'orderSubmit':0,
          2: 'orderDemand',
          3: 'orderPlan',
          4: 'orderAsk',
          8: 'companyAnnouncement',
        };
        const res = await Api.saveApprovalProcessSwitch({
          dataType: dataType[index],
          data: this.flag[index] ? '41' : '42',
        });
        if (res.code === '200') {
          const message = this.flag[index] ? '审批流打开' : '审批流关闭';
          this.$message.success(message);
        }
      }
    },
    chooseApproveFlow(inx) {
      // this.$store.state.tagsList.map((item, index) => {
      //           if (item.fullPath == this.$route.path) {
      //               this.$store.state.tagsList.splice(index, 1);
      //           }
      //       })
      switch (inx) {
        case 0:
          this.$router.push({ path: '/orderApprove' });
          break;
        case 2:
          this.$router.push({ path: '/requirementApprove' });
          break;
        case 3:
          this.$router.push({ path: '/purchaseApprove' });
          break;
        case 4:
          this.$router.push({ path: '/enquireApprove' });
          break;
        case 6:
          this.$router.push({ path: '/vendorPricing' });
          break;
        case 8:
          this.$router.push({ path: '/approve/announcement' });
          break;
        default:
          break;
      }
    },
    // 审批流开关查询
    async queryApprovalProcessSwitch() {
      const dataType = {
        // 'orderSubmit':0,
        orderDemand: 2,
        orderPlan: 3,
        orderAsk: 4,
        companyAnnouncement: 8,
      };

      const res = await Api.queryApproveSetting();
      if (res.code === '200') {
        res.data.forEach((item) => {
          const inx = dataType[item.dataType];
          if (item.data === '41') {
            this.$set(this.flag, inx, true);
            // this.flag[inx] = true; //v-model不能响应
          } else {
            this.$set(this.flag, inx, false);
            // this.flag[inx] = false;
          }
        });
      }
    },

    // 订单审批流开关查询
    async queryOrderApprovalProcessSwitch() {
      const res = await CompnanyApi.queryApprovalProcessSwitch();
      if (res.code === '200') {
        if (res.data.data === '41') {
          this.$set(this.flag, 0, true);
        } else {
          this.$set(this.flag, 0, false);
        }
      } else {
        this.$set(this.flag, 0, false);
      }
    },
    // 修改订单审批流开关
    async handleOrderSwitch(val) {
      const switchFlag = await CompnanyApi.listWorkflow();
      if (switchFlag.data.length) {
        const res = await CompnanyApi.saveApprovalProcessSwitch({
          data: val ? '41' : '42',
        });
        if (res.code === '200') {
          const message = val ? '审批流打开' : '审批流关闭';
          this.$message.success(message);
          // this.getWorkflowList();
        }
      } else {
        this.$set(this.flag, 0, false);
        this.$message({
          type: 'warning',
          message: '请至少添加一条审批流程后再开启审批开关',
          duration: 1000,
        });
      }
    },
    // 修改选商定价审批流开关
    async handleOrderAskPriceSwitch(val) {
      console.log(val, 'ssssssss');
      const params = {
        auditName: '',
        createMemberName: '',
        pageSize: 10,
        pageNum: 1,
        auditTypeList: [4, 6],
      };
      const resListWorkflow = await Api.listWorkflow(params);
      if (resListWorkflow.data.records.length > 0) {
        const res = await CompnanyApi.saveOrderAskPrice({
          data: val ? '41' : '42',
        });
        if (res.code === '200') {
          const message = val ? '审批流打开' : '审批流关闭';
          this.$message.success(message);
        }
      } else {
        this.$set(this.flag, 6, false);
        this.$message({
          type: 'warning',
          message: '请至少添加一条审批流程后再开启审批开关',
          duration: 1000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.approve {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 90px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 20px;
  .left {
    display: flex;
    .circle {
      width: 90px;
      height: 90px;
      border-radius: 50%;
      background: #ffffff;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -20px;
      margin-left: -60px;
      img {
        width: 50px;
        height: 50px;
      }
    }
    .left-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 30px;
      .purchase-name {
        font-size: 16px;
        color: #333333;
      }
      .purchase-desc {
        font-size: 14px;
        color: #333333;
      }
    }
  }

  .right {
    height: 100%;
    display: flex;
    align-items: flex-end;
  }
}
</style>
